import {createAction} from '@reduxjs/toolkit'

export const showDemoEvents = createAction('SHOW_DEMO_EVENTS')

export const showNoEvents = createAction<boolean>('SHOW_NO_EVENTS')
